module.exports = __webpack_public_path__ + "static/media/customer.3cd09cc5.png";